/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SyncJobFailure } from './syncJobFailure';

export interface SyncJobResponse {
  id: string;
  status: string;
  total: number;
  push_eligible: number;
  push_ok: number;
  push_failed: number;
  failures?: SyncJobFailure[];
  error_message?: string | null;
  finished_at?: string | null;
}
